import http, { Http } from '@/lib/http';
import { OnboardingStatus } from '@/pages/app/project/types';

export type AgreementType =
  | 'fee_agreement'
  | 'merchant_agreement'
  | 'role_terms_of_service'
  | 'terms_of_service'
  | 'terms_of_service_quiz';

export interface Agreements {
  agreementId: string;
  fileName: string;
  type: AgreementType;
}

export interface ProjectState {
  id: string;
  name: string;
  createdAt: Date;
  currentUserRoleName: string;
  projectMissingAgreements: Agreements[];
  states: {
    onboardingState: {
      status: OnboardingStatus;
      hasWatchedWelcomeVideo: boolean;
    };
  };
  features: {
    lnplEnabled: boolean;
    ppmEnabled: boolean;
    payInFullEnabled: boolean;
    analyticsEnabled: boolean;
    checkoutV2Enabled: boolean;
    userPilotEnabled: boolean;
    userManagementEnabled: boolean;
    invoicingEnabled: boolean;
    checkoutSalesTaxEnabled: boolean;
    offSchedulePaymentsEnabled: boolean;
    makePaymentEnabled: boolean;
    editScheduleEnabled: boolean;
  };
  configs: {
    checkoutSalesConfigured: boolean;
    refundEnabled: boolean;
    minPrice: number;
    maxPrice: number;
  };
  lenderIds: string[];
}

function ctor(http: Http) {
  return async (projectId: string) => {
    const { data } = await http.get<ProjectState>(`/projects/${projectId}/state`);
    return data;
  };
}

export const getProjectState = ctor(http);
